<div #dropdown="ngbDropdown" (openChange)="closeCall($event)" class="d-none d-lg-flex w-100" container="body" ngbDropdown>
  <button [disabled]="disabled"
          class="{{'d-flex w-100 justify-content-center align-items-center btn '+(selectedData?.length > 0 ? 'btn-hover-primary--active' : 'btn-hover-primary')}}"
          container="body" id="dropdowncolumns"
          ngbDropdownToggle
          ngbTooltip="{{tooltip}}"
          placement="top">
    <sb-icon *ngIf="showIcon" icon="{{getColumnIcon()}}"></sb-icon>
    <span *ngIf="showText" [innerHtml]="getButtonText() | truncate: (getHeadline().length + 2)" class="mx-1"> </span>
    <sb-icon *ngIf="showChevronDown" [icon]="'chevronDown'" class="ml-2" style=""></sb-icon>
  </button>
  <div *ngIf="!disabled" aria-labelledby="dropdowncolumns" ngbDropdownMenu style="width: 400px">
    <!--    <div class="d-flex align-items-center justify-content-between" style="padding: 10px 15px;">
          <div *ngIf="singleSelectMode && selectedData.length > 0">
            <button (click)="deselectAll()" class="btn btn-danger" container="body"
                    ngbTooltip="{{'lang.globals.deselect' | translate}}"
                    style="height: 40px">
              <sb-icon [icon]="'error'"></sb-icon>
            </button>
          </div>
        </div>-->
    <div *ngIf="!singleSelectMode && selectedData?.length > 0" class="d-flex justify-content-between"
         style="height: 40px; padding: 0 8px;">
      <div class="d-flex">
        <div
          *ngFor="let column of selectedData; index as i; last as last">
          <div *ngIf="i < 3" class="d-flex align-items-center px-1">
            <button [ngbTooltip]="column" class="btn btn-default"
                    placement="top" container="body">
            <span [innerHTML]="column | truncate: 3"
                  class="ml-1"></span>
              &nbsp;
              <sb-icon (click)="checkColumn($event, column)" icon="error"></sb-icon>
            </button>
          </div>
          <span *ngIf="i === 3" class="pl-1 pr-2 d-flex align-items-center h-100">
          (+{{ selectedData?.length - 3 }})
        </span>

        </div>
      </div>
      <div>
        <button (click)="deselectAll()" class="btn btn-danger" container="body"
                ngbTooltip="{{'lang.globals.deselectAll' | translate}}">
          <sb-icon [icon]="'error'"></sb-icon>
        </button>
      </div>
    </div>
    <div *ngIf="!singleSelectMode && selectedData?.length === 0"
         class="d-flex align-items-center justify-content-center" style="height: 40px;">
      <span>
        {{ 'lang.globals.noSelected' | translate }}{{ getButtonText() }}
      </span>
    </div>
    <hr *ngIf="!singleSelectMode" class="hrColoring mb-0">
    <div style="padding: 10px;">
      <div class="input-group">
        <span class="input-group-text" style="
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
"><sb-icon class="icon-in-btn" icon="search"></sb-icon> </span>
        <input (ngModelChange)="frontendSearch? searchLocally(): requestDebounced()" [(ngModel)]="msOptions.search" class="form-control"
               placeholder="{{getHeadline()}}" type="text">
      </div>
      <span *ngIf="!hidePagination" class="fake-small">{{ paginationString }}</span>
    </div>
    <ng-scrollbar class="ps-show-always" style="height: 200px">
      <div>
        <div (click)="checkColumn($event, column)" *ngFor="let column of frontendSearch? filteredDropDownData : dropDownData "
             class="fakeCol">
          <div [ngClass]="{'mnSelected' : selectedData?.includes(column)}">
            <label class="cont">
              <div>

                <sb-icon *ngIf="showColumnIcon" [icon]="getColumnIcon()"
                         class="cursor-help mr-2" style="display: inline-block;">
                </sb-icon>
                <span [innerHtml]="column |truncate: 35"></span>
              </div>
              <!--            <input type="checkbox" [checked]="checkIfSelected(column)">
                          <span class="checkmark"></span>-->
              <sb-icon *ngIf="selectedData?.includes(column) && !singleSelectMode" icon="checked"></sb-icon>
            </label>
          </div>
        </div>
      </div>
    </ng-scrollbar>
    <div *ngIf="!hidePagination" class="d-flex align-items-center" style="padding: 2px 10px">
      <div (pageChange)="pageChange($event)" *ngIf="paginationInitialized" [(page)]="page"
           [boundaryLinks]="boundaryLinks"
           [collectionSize]="collectionSize" [maxSize]="maxSize"
           [showGotoPage]="false" [showPageCount]="false" [showPageSize]="false"
           class="w-100" sb-pagination>
        {{ paginationString }}
      </div>
    </div>
    <hr *ngIf="showSubmit" class="mb-2" style="margin-top: -0.5rem">
    <div *ngIf="showSubmit" class="d-flex justify-content-between">
      <div style="padding-bottom: 10px; padding-left: 10px;">
        <button class="btn btn-default" ngbDropdownToggle>{{ 'lang.globals.cancel'|translate }}</button>
      </div>
      <div style="padding-right: 10px; padding-bottom: 10px;">
        <button (click)="submit()" class="btn btn-primary">{{ 'lang.globals.submit'|translate }}</button>
      </div>
    </div>
  </div>
</div>


<div class="d-flex d-lg-none tableBg">
  <button (click)="toggleModalDropdownSelect()" [disabled]="disabled"
          class="{{'btn '+(selectedData?.length > 0 ? 'btn-hover-primary--active' : 'btn-hover-primary')}}"
          container="body" ngbTooltip="{{tooltip}}"
          placement="top"
          style="width: 100%">
    <sb-icon *ngIf="showIcon" icon="{{getColumnIcon()}}"></sb-icon>
    <span *ngIf="showText" class="mr-1">
      {{ getButtonText() }} </span>
  </button>
  <div *ngIf="showModalLike" class="modalLike tableBg" style="min-width: 400px">
    <div *ngIf="!singleSelectMode && selectedData?.length > 0" class="d-flex justify-content-between">
      <div class="d-flex">
        <div
          *ngFor="let column of selectedData; index as i; last as last">
          <div *ngIf="i < 3" class="d-flex align-items-center px-1">
            <button [ngbTooltip]="column" class="btn btn-default"
                    placement="top" container="body">
            <span [innerHTML]="column | truncate: 3"
                  class="ml-1"></span>
              &nbsp;
              <sb-icon (click)="checkColumn($event, column)" icon="error"></sb-icon>
            </button>
          </div>
          <span *ngIf="i === 3" class="pl-1 pr-2 d-flex align-items-center h-100">
          (+{{ selectedData?.length - 3 }})
        </span>

        </div>
      </div>
      <div>
        <button (click)="deselectAll()" class="btn btn-danger"
                ngbTooltip="{{'lang.globals.deselectAll' | translate}}"
                style="height: 40px" container="body">
          <sb-icon [icon]="'error'"></sb-icon>
        </button>
      </div>
    </div>
    <div *ngIf="!singleSelectMode && selectedData?.length === 0"
         class="d-flex align-items-center justify-content-center"
         style="height: 40px">
      <span>
        {{ 'lang.globals.noSelected' | translate }}{{ getButtonText() }}
      </span>
    </div>
    <hr *ngIf="!singleSelectMode" class="hrColoring">
    <!---->
    <div style="padding: 10px;">
      <div class="input-group">
        <span class="input-group-text"
              style="border-right: 0; border-top-right-radius: 0; border-bottom-right-radius: 0;">
          <sb-icon class="icon-in-btn" icon="search"></sb-icon>
        </span>
        <input (ngModelChange)="requestDebounced()" [(ngModel)]="msOptions.search" class="form-control"
               placeholder="{{getHeadline()}}" type="text">
      </div>
      <span *ngIf="!hidePagination" class="fake-small">{{ paginationString }}</span>
    </div>
    <!---->
    <div class="scrollDropdownColumnSelect">
      <div>
        <div (click)="checkColumn($event, column)" *ngFor="let column of dropDownData"
             class="fakeCol">
          <div [ngClass]="{'mnSelected' : selectedData?.includes(column)}">
            <label class="cont">
              <div>

                <sb-icon *ngIf="showColumnIcon" [icon]="getColumnIcon()"
                         class="cursor-help mr-2" style="display: inline-block;">
                </sb-icon>
                <span [innerHtml]="column|truncate: 50"></span>
              </div>
              <!--            <input type="checkbox" [checked]="checkIfSelected(column)">
                          <span class="checkmark"></span>-->
              <sb-icon *ngIf="selectedData?.includes(column) && !singleSelectMode" icon="checked"></sb-icon>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center" style="padding-bottom: 10px; padding-left: 10px;">
      <div (pageChange)="pageChange($event)" *ngIf="paginationInitialized" [(page)]="page"
           [boundaryLinks]="boundaryLinks" [collectionSize]="collectionSize"
           [maxSize]="maxSize" [showGotoPage]="false" [showPageCount]="false"
           [showPageSize]="false" class="w-100" sb-pagination>
        {{ paginationString }}
      </div>
    </div>
    <hr *ngIf="showSubmit" class="mb-2" style="margin-top: -0.5rem">
    <div *ngIf="showSubmit" class="d-flex justify-content-between">
      <div style="padding-bottom: 10px; padding-left: 10px;">
        <button (click)="toggleModalDropdownSelect()"
                class="btn btn-primary">{{ 'lang.globals.cancel'|translate }}
        </button>
      </div>
      <div style="padding-right: 10px; padding-bottom: 10px;">
        <button (click)="submit()" class="btn btn-primary">{{ 'lang.globals.submit'|translate }}</button>
      </div>

    </div>
  </div>
</div>
